<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>

    <div class="container">
      <div style="border: solid 1px #c9cbd6;">
        <el-table ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%;min-width:1000px;"
                  :header-cell-style="{background:'#F5F5F5'}">
          <el-table-column label="开方时间"
                           prop="create_time"></el-table-column>
          <el-table-column label="药方费用"
                           prop="drug_price"></el-table-column>
          <el-table-column label="诊金"
                           prop="consulting_gold">
            <template slot-scope="scope">
              <span>{{scope.row.consulting_gold=="0.00"?"免费":scope.row.consulting_gold}}</span>
            </template>
          </el-table-column>
          <el-table-column label="科室"
                           prop="department_name"></el-table-column>

          <el-table-column prop="doctor_name"
                           label="医生姓名">
            <template slot-scope="scope">
              <span @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer">{{scope.row.doctor_name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="职称"
                           prop="title"></el-table-column>
          <el-table-column label="手机号"
                           prop="phone"></el-table-column>

          <el-table-column label="处方状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">待取药</span>
              <span v-if="scope.row.status==2">待审方</span>
              <span v-if="scope.row.status==3">已通过</span>
              <span v-if="scope.row.status==4">已抓药</span>
              <span v-if="scope.row.status==5">已失效</span>
              <span v-if="scope.row.status==6">已失效</span>
              <span v-if="scope.row.status==7">已失效</span>
              <span v-if="scope.row.status==8">已失效</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text"
                         @click="toDetail(scope.row.pre_id)"
                         :disabled="module_id_array[0]?!module_id_array.includes('56'):false">查看处方</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import yewu from '../../../api/yewu';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      tableData: [],
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取认证记录列表
    getLogList() {
      let data = {
        page: 1,
        pageNumber: 1000,
        prescription_status: 0,
        patient_id: this.$route.query.patient_id,
        user_id: this.$route.query.user_id
      };
      yewu
        .prescriptionList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = platform.timestampToTime(item.create_time);
              return item;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //查看详情
    toDetail(pre_id) {
      this.$router.push({
        path: '/home/yewu/chufangdetail',
        query: {
          pre_id
        }
      });
    }
  },
  created() {
    this.getLogList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>


